<script>
import Translatable from '@src/mixins/translatable.js'
import ExampleDayCard from '@components/pass-and-card/example-day-card.vue'

export default {
  mixins: [
    Translatable
  ],
  props: {
    attractions: {
      type: Array,
      required: true
    },
    day: {
      type: Number
    }
  },
  components: {
    ExampleDayCard
  },
}
</script>

<template>
  <div class="day">
    <div class="header">
      <p class="header-title">{{ getTranslatedContent(`PASS_AND_CARD_example_day_${day}`) }}</p>
      <p class="header-price-title">{{ getTranslatedContent('PASS_AND_CARD_normal_price_label') }}</p>
    </div>
    <div class="card" v-for="attraction in attractions" :key="attraction._id">
      <ExampleDayCard :attraction="attraction"/>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.header {
  display: flex;
  justify-content: space-between;
  height: 24px;
  padding: 27px 10px;
}

.header-title {
  font-family: Open Sans Bold, sans-serif;
  font-weight: bold;
  font-size: 18px;
  line-height: 23px;
  text-transform: uppercase;
  color: $dark-blue;
}

.header-price-title {
  font-family: Open Sans Bold, sans-serif;
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  margin-right: 10px;
  margin-top: 2px;
  color: $dark-blue;
}

.day {
  min-height: 80px;
  height: auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  box-shadow: 0px 8px 12px rgba(76, 72, 124, 0.08);
  background-color: $light-gray;
  margin-bottom: auto
}

@media only screen and (min-width: $mobile-screen-width) and (max-width: $container-width-xs) {

  .header-title {
    font-size: 14px;
    line-height: 18px;
  }

  .header-price-title {
    font-family: Open Sans Semibold, sans-serif;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    text-transform: uppercase;
    width: 85px;
  }
}
</style>
